import React, { useEffect } from "react";
import "./css/PageLayout.css"; // Ensure you have the correct path
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();
  
  // Scroll to top when route changes
  useEffect(() => {
    // Scroll window to top
    window.scrollTo(0, 0);
    // Also scroll the root element if it's scrollable
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.scrollTop = 0;
    }
  }, [location.pathname]);
  
  return (
    <div className="app-container">
      <Outlet />
    </div>
  );
};

export default Layout;
